import {
    FORM_DIRECTIVES, REACTIVE_FORM_DIRECTIVES, FORM_PROVIDERS, FormGroup, FormControl,
    Validators
} from "@angular/forms";
import {AlertComponent, TYPEAHEAD_DIRECTIVES, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from "ng2-bootstrap/ng2-bootstrap";
import {Component, OnDestroy, OnInit, Input, Output, ViewChild, ElementRef} from "@angular/core";
import {DEFAULT_ERROR_MESSAGES} from "../../validators/validators";
import {ActivatedRoute} from "@angular/router";
import {EventEmitter} from "@angular/router-deprecated/src/facade/async";
import {State} from "../../domain/state";
import {CitiesService} from "../../service/cities.service";
import {City} from "../../domain/city";
import {DragulaService, Dragula} from "ng2-dragula/ng2-dragula";

/**
 * .
 * Created by jlado on 1/23/17.
 */
@Component({
    selector: 'state-editor',
    template: require('./state.editor.component.html'),
    styles: [require('./state.editor.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        TYPEAHEAD_DIRECTIVES,
        MODAL_DIRECTIVES,
        Dragula
    ],
    providers: [
        FORM_PROVIDERS,
        BS_VIEW_PROVIDERS,
        DragulaService
    ],
})
export class StateEditorComponent implements OnInit, OnDestroy {

    @Input() public state:State;
    @Output() private close = new EventEmitter();

    public cities:City[];

    public newCity:City;

    public citySelected:City;

    public errorMessages:any;
    public errorMessage:string;
    public successMessage:string;

    private sub:any;
    public stateForm:FormGroup;
    public cityForm:FormGroup;
    public newCityForm:FormGroup;

    public stateId:string;

    public createMode:boolean;
    public editMode:boolean;
    public loading:boolean;
    private deleteMode:boolean;

    @ViewChild('scrollMe') divToScroll:ElementRef;

    constructor(private citiesService:CitiesService,
                private route:ActivatedRoute,
                private dragulaService:DragulaService) {
        this.init();

        dragulaService.setOptions('cities-bag', {
            direction: 'vertical',
            /*Elements in source cant be reordered*/
            copySortSource: false,
            moves: function () {
                return false;
            }
        });
    }

    private init():void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.loading = false;
        this.deleteMode = false;
        this.editMode = false;

        this.state = new State();
        this.cities = [];
        this.newCity = new City(null);

        this.citySelected = new City(null);
    }

    public ngOnInit():any {
        this.createStateFormGroup();

        this.sub = this.route.params.subscribe(params => {
            let stateId = params['stateId'];
            if (stateId) {
                this.stateId = stateId;
                this.createMode = false;
            } else {
                this.stateId = null;
                this.createMode = true;
            }
            this.getData();
        });
    }

    public ngOnDestroy():any {
        this.sub.unsubscribe();
    }

    private createStateFormGroup():void {
        let group:any = {};
        group['nameState'] = new FormControl(this.state.name, [Validators.required]);

        this.stateForm = new FormGroup(group);

        group = {};
        group['nameNewCity'] = new FormControl(this.newCity.name, [Validators.required]);
        this.newCityForm = new FormGroup(group);
    }

    private createCityFormGroup():void {
        let group:any = {};
        group['nameCity'] = new FormControl(this.citySelected.name, [Validators.required]);

        this.cityForm = new FormGroup(group);
    }

    private getData():void {
        if (this.stateId) {
            this.loading = true;
            this.citiesService.getCities(this.stateId).subscribe(
                (data) => {
                    this.setData(data[0].state);
                    this.cities = data;
                    this.newCity.state = data[0].state;
                },
                () => {
                    this.bindError('Ocurrió un error al obtener los datos y localidades de la provincia.');
                });
        }
    }

    private setData(data:any):void {
        this.loading = false;

        if (this.stateId) {
            this.state = data;
        } else {
            this.state = new State();
        }
    }

    public saveState():void {
        this.clearMessages();
        this.loading = true;

        this.citiesService.saveState(this.state).subscribe(
            (saved:State) => {
                this.loading = false;
                this.state = saved;
                this.createMode = false;
                this.stateId = saved.id;
                this.successMessage = 'La provincia se guardó con éxito';
            },
            () => {
                this.bindError('Ocurrió un error al guardar los datos de la provincia.');
            });
    }

    public saveCity(city:City):void {
        this.clearMessages();
        this.loading = true;

        city.state = this.state;
        this.citiesService.saveCity(city).subscribe(
            () => {
                this.loading = false;
                this.editMode = false;
                this.citySelected = null;
                this.getData();
                this.successMessage = 'La localidad se guardó con éxito';
            },
            () => {
                this.bindError('Ocurrió un error al guardar los datos de la localidad.');
            });
    }

    private clearMessages():void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    public goBack(event:any):void {
        event.preventDefault();
        this.close.emit(this.state);
        window.history.back();
    }

    public removeCity(deleteModal:any):void {
        this.clearMessages();
        this.citiesService.deleteCity(this.citySelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeStateFromView(this.citySelected);
                this.deleteMode = true;
                this.successMessage = 'La localidad se eliminó con éxito.';
            },
            () => {
                this.bindError('Ocurrió un error al eliminar la localidad.');
            });
    }

    private removeStateFromView(city:City):void {
        let index = this.cities.indexOf(city);
        if (index > -1) {
            this.cities.splice(index, 1);
        }
        this.citySelected = null;
    }

    public editCity(city:City):void {
        this.citySelected = city;
        this.createCityFormGroup();
        this.editMode = true;
        this.divToScroll.nativeElement.scrollIntoView(false);
    }

    public cancelCity():void {
        this.citySelected = null;
        this.editMode = false;
    }

    public addNewCity():void {
        this.newCity.state = this.state;
        this.saveCity(this.newCity);
        this.newCity = new City(null);
        this.getData();
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/states/state.editor.component.ts
 **/